var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"langPage transitionSlide"},[_c('div',{staticClass:"collpase",class:_vm.showLeftCon ? '' : 'hideLeftCon'},[_c('div',{staticClass:"leftCon"},[_vm._t("leftLanding")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }